var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ScrollShadow',[_c('div',{staticClass:"selected-products"},[_vm._t("title"),_c('hr',{staticClass:"selected-products-divider"}),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }